// extracted by mini-css-extract-plugin
export var aboveInput = "_m1-0";
export var actionButton = "_m1-5";
export var actionButtonContainer = "_m1-1";
export var actionIcon = "_m1-6";
export var aiInfoContainer = "_m1-2";
export var attachmentWrapper = "_m1-7";
export var bold = "_m1-3";
export var checkIcon = "_m1-8";
export var clickingRecipientBar = "_m1-11";
export var commentThreadSwitch = "_m1-a";
export var draftImage = "_m1-b";
export var draftImageContainer = "_m1-c";
export var draftImages = "_m1-e";
export var editButton = "_m1-g";
export var editor = "_m1-f";
export var editorContainer = "_m1-y";
export var editorErrorTooltipWrapper = "_m1-9";
export var headerDivider = "_m1-h";
export var icon = "_m1-i";
export var info = "_m1-j";
export var internal = "_m1-n";
export var internalDivider = "_m1-k";
export var internalMessage = "_m1-l";
export var messageInputCard = "_m1-m";
export var messageInputForm = "_m1-o";
export var messageInputFormInternal = "_m1-p";
export var options = "_m1-q";
export var publicMessageCustomer = "_m1-s";
export var publicMessageMerchant = "_m1-r";
export var removeImageButton = "_m1-d";
export var replyButtons = "_m1-t";
export var showSignatureButton = "_m1-u";
export var spinner = "_m1-v";
export var verticalButtonDivider = "_m1-4";
export var visibilitySelector = "_m1-w";
export var warning = "_m1-x";
export var wrappingText = "_m1-z";
export var writingInternalNoteTopBorder = "_m1-10";